import {ESBA_DATE_FORMAT} from 'common';
import {fullName} from 'core/domain';
import {format, parseISO} from "date-fns";
import {Heading, HeadingProps} from 'evergreen-ui';
import {Offer} from 'offer';
import React from 'react';

type SubmissionInfoProps = {
    offer: Offer;
} & HeadingProps;
export const SubmissionInfo = ({offer, ...rest}: SubmissionInfoProps) => {
    const submittedAt = parseISO(offer.submittedAt);
    return (
        <Heading size={500} marginTop={16} {...rest}>
            Submitted
            by {fullName(offer.submittedBy)} on {format(submittedAt, ESBA_DATE_FORMAT)} at {format(submittedAt, 'h:mm a')}
        </Heading>
    );
}
